import AuthProtectedPage from 'app/routes/auth/AuthProtectedPage';
import React from 'react';
import ExperimentalPage from 'app/routes/settings/ExperimentalPage';
import {useExperimental} from 'app/hooks/useExperimental';
import {useSelector} from 'react-redux';
import {selectAuthState} from 'app/hooks/reduxCreateSelectorHooks';

const ExperimentalPageWrapper = props => {
  const experimental = useExperimental();
  const isAuthenticated = useSelector(selectAuthState);
  return isAuthenticated && experimental ? (
    <ExperimentalPage />
  ) : (
    <AuthProtectedPage loading={props.initializing || (isAuthenticated && !experimental)} />
  );
};

export default ExperimentalPageWrapper;
